
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
import TextTips from "@common/src/components/scope/text-tips/index.vue";
import { addCurrencyUnit } from "@common/src/utils/tools";
import { checkMoney, percentageRules } from "@common/src/utils/verify";

const employee = namespace("employee");
const base = namespace("base");

@Component({ components: { TextTips } })
@Table("queryCategorySubList")
export default class Template extends Vue {
  @employee.State currentTabTypePushMoney;
  @employee.Mutation setCurrentTabTypePushMoney;
  @employee.Action queryCategoryCommission;
  @employee.Action createBusinessCommission;
  @employee.Action queryServicesCommission;
  @employee.Action queryPartsCommission;
  @employee.Action deleteBusinessCommission;
  @base.Action getDictionaryList;
  get tabBarData() {
    return [
      { tabName: t("v210831.project-commission"), type: "project" },
      { tabName: t("v210831.parts-commission"), type: "parts" }
    ];
  }
  handleSwitchStatus(tab) {
    this.setCurrentTabTypePushMoney(tab.type);
    if (tab.type === "project") {
      this.commissionAmountTypeList = this.serviceCommissionAmountTypeList;
    } else {
      this.commissionAmountTypeList = this.partsCommissionAmountTypeList;
    }
    this.mix_pageNum = 1;
    this.queryCategoryList();
  }
  created() {
    this.queryCategoryList();
    this.init();
  }
  categoryList: any = [];
  commissionTypeList: any = [];
  commissionAmountTypeList: any = [];
  partsCommissionAmountTypeList: any = [];
  serviceCommissionAmountTypeList: any = [];
  init() {
    this.getDictionaryList("commission_type").then(data => {
      this.commissionTypeList = data;
    });
    this.getDictionaryList("commission_amount_type").then(data => {
      this.partsCommissionAmountTypeList = data;
      // 项目提成 没有毛利
      this.serviceCommissionAmountTypeList = data.filter(item => item.value !== "gross");
      this.commissionAmountTypeList = this.serviceCommissionAmountTypeList;
    });
  }

  queryCategoryList() {
    return this.queryCategoryCommission({
      businessType: this.currentTabTypePushMoney === "project" ? "serviceCategory" : "partsCategory",
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      const categoryList = data.data.list;
      for (let i = 0; i < categoryList.length; i++) {
        let item = categoryList[i];
        item.commissionTypeDesc = t("v213.sale");
        item.commissionType = "sale";
        item.editing = false;
        item.sameCatogoryIndex = [i, i + 1];
        item.saleCommission = item.saleCommission || { arrivalCommissionAmountType: "" };
        item.serviceCommission = item.serviceCommission || { arrivalCommissionAmountType: "" };
        item.commissionValue = item.saleCommission?.arrivalIntervalList?.[0]?.commissionValue || "";
        // 由于第二层对象浅拷贝，拎出来
        item.commissionAmountType = item.saleCommission?.arrivalCommissionAmountType || "";
        item.originRow = Object.assign({}, item);
        categoryList.splice(
          i + 1,
          0,
          Object.assign({}, item, {
            commissionTypeDesc: t("layout.server"),
            commissionType: "service",
            commissionValue: item.serviceCommission?.arrivalIntervalList?.[0]?.commissionValue || "",
            commissionAmountType: item.serviceCommission?.arrivalCommissionAmountType || ""
          })
        );
        //存放原始数据
        categoryList[i + 1].originRow = Object.assign({}, categoryList[i + 1]);
        // splice 往后添加一个item，所以直接跳过下一个
        i++;
      }
      this.categoryList = categoryList;
      this.handleQueryCategoryItemList(this.categoryList[0]);
      return data;
    });
  }

  spanMethod({ rowIndex, columnIndex }) {
    if (columnIndex === 0 || columnIndex === 4) {
      if (rowIndex % 2 === 0) {
        return {
          rowspan: 2,
          colspan: 1
        };
      } else {
        return {
          rowspan: 0,
          colspan: 0
        };
      }
    }
  }
  searchKey = "";
  handleSearchOnAccountCustomer() {
    this.mix_pageNum = 1;
    this.queryCategorySubList();
  }
  handleQuickSet(row) {
    row.sameCatogoryIndex.forEach(index => {
      this.categoryList[index].editing = true;
    });
  }
  handleCancelSet(row) {
    row.sameCatogoryIndex.forEach(index => {
      const itemRow = this.categoryList[index];
      this.categoryList[index].editing = false;
      if (itemRow.commissionType === "sale") {
        itemRow.saleCommissionType = itemRow.originRow.saleCommissionType;
        itemRow.saleCommission.arrivalCommissionAmountType = itemRow.originRow?.commissionAmountType || "";
        itemRow.commissionValue = itemRow.originRow.commissionValue;
      } else {
        itemRow.serviceCommissionType = itemRow.originRow.serviceCommissionType;
        itemRow.serviceCommission.arrivalCommissionAmountType = itemRow.originRow?.commissionAmountType || "";
      }
      itemRow.commissionValue = itemRow.originRow.commissionValue;
    });
  }
  handleSaveCommissionSet(row) {
    const saleCommissionType = this.categoryList[row.sameCatogoryIndex[0]].saleCommissionType;
    const serviceCommissionType = this.categoryList[row.sameCatogoryIndex[1]].serviceCommissionType;
    if (saleCommissionType !== "none") {
      if (!this.categoryList[row.sameCatogoryIndex[0]].saleCommission.arrivalCommissionAmountType) {
        return this.$message.error(t("v213.please-select-a-complete-commission-method"));
      }
      if (saleCommissionType === "proportion") {
        const checkResult = percentageRules(
          this.categoryList[row.sameCatogoryIndex[0]].commissionValue,
          t("v210831.percentage-of-commission")
        );
        if (!checkResult.success) {
          return this.$message.error(checkResult.msg);
        }
      } else {
        const checkResult = checkMoney(this.categoryList[row.sameCatogoryIndex[0]].commissionValue).success;
        if (!checkResult) {
          return this.$message.error(t("v213.the-commission-amount-is-a-numerical-decimal-places"));
        }
      }
    }
    if (serviceCommissionType !== "none") {
      if (!this.categoryList[row.sameCatogoryIndex[1]].serviceCommission.arrivalCommissionAmountType) {
        return this.$message.error(t("v213.please-select-a-complete-commission-method"));
      }
      if (serviceCommissionType === "proportion") {
        const checkResult = percentageRules(
          this.categoryList[row.sameCatogoryIndex[1]].commissionValue,
          t("v210831.percentage-of-commission")
        );
        if (!checkResult.success) {
          return this.$message.error(checkResult.msg);
        }
      } else {
        const checkResult = checkMoney(this.categoryList[row.sameCatogoryIndex[1]].commissionValue).success;
        if (!checkResult) {
          return this.$message.error(t("v213.the-commission-amount-is-a-numerical-decimal-places"));
        }
      }
    }
    const commissionJSON = {
      saleCommissionType: this.categoryList[row.sameCatogoryIndex[0]].saleCommissionType,
      serviceCommissionType: this.categoryList[row.sameCatogoryIndex[1]].serviceCommissionType,
      saleCommissionAmountType: this.categoryList[row.sameCatogoryIndex[0]].saleCommission.arrivalCommissionAmountType,
      serviceCommissionAmountType:
        this.categoryList[row.sameCatogoryIndex[1]].serviceCommission.arrivalCommissionAmountType,
      saleIntervalList: [{ commissionValue: this.categoryList[row.sameCatogoryIndex[0]].commissionValue }],
      serviceIntervalList: [{ commissionValue: this.categoryList[row.sameCatogoryIndex[1]].commissionValue }]
    };
    const params = {
      businessType: this.currentTabTypePushMoney === "project" ? "serviceCategory" : "partsCategory",
      businessList: [
        {
          businessCode: row.categoryCode,
          businessNumber: row.categoryCode
        }
      ],
      arrivalCommission: commissionJSON,
      externalCommission: commissionJSON
    };
    this.createBusinessCommission(params).then(data => {
      console.log(data);
      this.queryCategoryList();
      row.editing = false;
    });
  }
  categoryDetailList: any = [];
  @Table.LoadDataMethod()
  queryCategorySubList(categoryCode?) {
    const queryFucn =
      this.currentTabTypePushMoney === "project" ? this.queryServicesCommission : this.queryPartsCommission;
    return queryFucn({
      serviceCategoryCode: categoryCode || this.currentCategoryCode,
      partsCategoryCode: categoryCode || this.currentCategoryCode,
      partsName: this.searchKey,
      serviceName: this.searchKey,
      notOpadmin: this.isShowPlatformItem ? 0 : 1,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.categoryDetailList = (data.data?.list || []).map(item => {
        item.businessName = item.serviceName || item.partsNameDesc;
        return item;
      });
      return data;
    });
  }

  isShowPlatformItem: boolean = false;
  currentCategoryCode = "";
  handleQueryCategoryItemList(row) {
    this.currentCategoryCode = row.categoryCode;
    this.queryCategorySubList();
  }
  natureFlag = true;
  handleNature(flag) {
    this.natureFlag = flag;
  }
  enumerateType(type) {
    switch (type) {
      case "order":
        return addCurrencyUnit(t("v210831.order-amount-range"), false, true);
      case "actual":
        return addCurrencyUnit(t("v210831.paid-in-amount-section"), false, true);
      case "gross":
        return addCurrencyUnit(t("v210831.gross-profit-amount"), false, true);
      case "proportion":
        return t("v210831.percentage-of-commission") + "(%)";
      case "fixed":
        return t("v210831.royalty-amount-yuan");
      default:
        return type;
    }
  }
  enter(row) {
    if (row.serviceCommission.arrivalCommissionType !== "none") {
      this.natureFlag = true;
    } else if (row.serviceCommission.externalCommissionType !== "none") {
      this.natureFlag = false;
    }
  }
  saleEnter(row) {
    if (row.saleCommission.arrivalCommissionType !== "none") {
      this.natureFlag = true;
    } else if (row.saleCommission.externalCommissionType !== "none") {
      this.natureFlag = false;
    }
  }
  selectRows: any = [];
  stringRows = "";
  handelSelect(selects) {
    this.selectRows = selects;
    let stringRows = selects.map(item => {
      return item.serviceCode || item.partsCode;
    });
    this.stringRows = stringRows.join(",");
  }
  handleEditSet(row) {
    if (!row && !this.stringRows) {
      return this.$message.warning(t("v260.please-select-item-or-spare-parts"));
    }
    if (row.noSetting === "1") {
      const { href } = this.$router.resolve(
        `/employee/emplyee-push-money/create-project-push-money?code=${row.serviceCode || row.partsCode}&type=${
          this.currentTabTypePushMoney === "project" ? "services" : "parts"
        }`
      );
      window.open(href);
    } else {
      const { href } = this.$router.resolve(
        `/employee/emplyee-push-money/edit-project-push-money?code=${row.serviceCode || row.partsCode}&type=${
          this.currentTabTypePushMoney === "project" ? "services" : "parts"
        }`
      );
      window.open(href);
    }
  }
  handleBatchEdit() {
    if (!this.stringRows) {
      return this.$message.warning(t("v260.please-select-item-or-spare-parts"));
    }
    this.$router.push(
      `/employee/emplyee-push-money/edit-project-push-money/?code=${this.stringRows}&type=${
        this.currentTabTypePushMoney === "project" ? "services" : "parts"
      }`
    );
  }
  handleShowResetAlert(row) {
    this.showResetAlert = true;
    this.activeRow = row;
  }
  handleShowPlatformItem() {
    this.queryCategorySubList();
  }
  handleCommissionTypeChange(type, row) {
    if (row.commissionType === "sale") {
      if (type === "none") {
        row.saleCommission.arrivalCommissionAmountType = "";
      }
      if (type === "fixed") {
        row.saleCommission.arrivalCommissionAmountType = "order";
      }
    }
    if (row.commissionType === "service") {
      if (type === "none") {
        row.serviceCommission.arrivalCommissionAmountType = "";
      }
      if (type === "fixed") {
        row.serviceCommission.arrivalCommissionAmountType = "order";
      }
    }

    row.commissionValue = "";
  }
  setCurrentRowClass({ row }) {
    if (row.categoryCode === this.currentCategoryCode) {
      return "current-row";
    } else {
      return "";
    }
  }
  showResetAlert = false;
  activeRow: any = {};
  handleCommissionReset() {
    this.deleteBusinessCommission({
      businessCodeList: [this.activeRow.serviceCode || this.activeRow.partsCode],
      businessType: this.currentTabTypePushMoney === "project" ? "services" : "parts"
    }).then(() => {
      this.$message.success(t("v213.reset"));
      this.queryCategorySubList();
      this.showResetAlert = false;
    });
  }
}
